<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M8.05547 5.83398C5.39881 7.25732 3.33325 10.8518 3.33325 13.8895C3.33325 17.5718 6.3177 18.6118 9.99992 18.6118C13.6821 18.6118 16.6666 17.5718 16.6666 13.8895C16.6666 10.8518 14.601 7.25732 11.9444 5.83398"
            fill="#E4EBFF"
        />
        <path
            d="M11.9444 5.83312L14.1666 2.49978C14.1666 1.88645 13.6688 1.38867 13.0555 1.38867H6.94436C6.33103 1.38867 5.83325 1.88645 5.83325 2.49978L8.05547 5.83312H11.9444Z"
            stroke="#007AFF"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M10 5.83268V4.16602"
            stroke="#007AFF"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8.05547 5.83398C5.39881 7.25732 3.33325 10.8518 3.33325 13.8895C3.33325 17.5718 6.3177 18.6118 9.99992 18.6118C13.6821 18.6118 16.6666 17.5718 16.6666 13.8895C16.6666 10.8518 14.601 7.25732 11.9444 5.83398"
            stroke="#007AFF"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M12.0201 9.44531H9.11604C8.34893 9.44531 7.72716 10.0671 7.72705 10.8341C7.72705 11.6013 8.34882 12.2233 9.11604 12.2233H10.884C11.6509 12.2233 12.2728 12.845 12.2728 13.612C12.2728 14.3791 11.651 15.0009 10.884 15.0009H7.9796"
            stroke="#007AFF"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M10 8.61133V9.44486"
            stroke="#007AFF"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M10 15V15.8336"
            stroke="#007AFF"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
